import { FormInput, FormSelect } from '../../../component/input/InputStyle';
import FormLabel from '../../../component/input/FormLabel.component';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import { Flags } from "../interfaces/Flags";
import flags from '../utils/Flags';
import { useState } from 'react';
import status from '../utils/Status';
import { FormInterface } from '../interfaces/FormComponent';
import { STATUS } from '../../../enum/status/Status';

export default function FormComponent({ handleChange, initialValues, setFieldValue, disabled }: FormInterface) {

    const [allFlags, setAllFlags] = useState<boolean>(false);

    const OnChangeFlags = () => {
        if (!setFieldValue) {
            return '';
        }
        setAllFlags(!allFlags);
        if (allFlags) {
            return setFieldValue('affectedFlag', []);
        }

        let flagsAux: Array<string> = [];
        flags.map((flag: Flags) => flagsAux.push(flag.value));
        return setFieldValue('affectedFlag', flagsAux);
    }

    return (
        <>
            <FormLabel title="Título" md={4} required={!disabled}>
                <FormInput
                    name="title"
                    value={initialValues.title}
                    onChange={handleChange}
                    disabled={disabled}
                    required
                />
            </FormLabel>
            <FormLabel title="TICKET" md={4} required={!disabled}>
                <FormInput
                    name="ticket"
                    value={initialValues.ticket}
                    onChange={handleChange}
                    disabled={disabled}
                    required
                />
            </FormLabel>
            <FormLabel title="SERVIÇO AFETADO INICIAL" md={4} required={!disabled}>
                <FormInput
                    name="initialAffectedService"
                    value={initialValues.initialAffectedService}
                    onChange={handleChange}
                    disabled={disabled}
                    required
                />
            </FormLabel>

            <FormLabel title="Pais" md={4} required={!disabled}>
                <FormSelect
                    name="idpais"
                    value={String(initialValues.idpais)}
                    onChange={handleChange}
                    defaultValue="0"
                    disabled={disabled}
                    required
                >
                    <MenuItem value="0" disabled>Selecione</MenuItem>
                    <MenuItem value="4">Brasil</MenuItem>
                </FormSelect>
            </FormLabel>

            <FormLabel title="Bandeira" md={4} required={!disabled}>
                <FormSelect
                    displayEmpty={true}
                    multiple
                    name="affectedFlag"
                    value={initialValues.affectedFlag}
                    onChange={handleChange}
                    defaultValue="0"
                    disabled={disabled}
                    renderValue={(selected: any) => (selected as string[]).join(', ')}
                    required
                >
                    <MenuItem value="0" disabled>Selecione</MenuItem>
                    <MenuItem value={'All'} >
                        <Checkbox checked={allFlags} onChange={OnChangeFlags} />
                        <ListItemText primary={'Cencosud'} />
                    </MenuItem>
                    {flags.map((flag: Flags, index: number) => {
                        return <MenuItem value={flag.value || index} key={index}>
                            <Checkbox checked={initialValues.affectedFlag.indexOf(flag.value) > -1} />
                            <ListItemText primary={flag.label} />
                        </MenuItem>
                    })}
                </FormSelect>
            </FormLabel>

            <FormLabel title="status" md={4} required={!disabled} >
                <FormSelect
                    name="type"
                    value={initialValues.type}
                    onChange={handleChange}
                    defaultValue=""
                    disabled={disabled}
                    required
                >
                    <MenuItem value={""} disabled>Selecione</MenuItem>
                    {initialValues.type === STATUS.Overview && <MenuItem value={STATUS.Overview}>Visão Geral</MenuItem>}
                    {initialValues.type === STATUS.Solved && <MenuItem value={STATUS.Solved}>Solucionado</MenuItem>}
                    {(initialValues.type !== STATUS.Overview && initialValues.type !== STATUS.Solved) && status.map((statusValues: Flags, index: number) => {
                        return <MenuItem value={statusValues.value || index} key={index}>{statusValues.label}</MenuItem>
                    })}
                </FormSelect>
            </FormLabel>
        </>
    )
}